import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const SpellingStyled = styled.span`
  border-bottom: 1px solid ${colors.red};
  cursor: default;
`;

export default SpellingStyled;
